import { c as _c } from "react/compiler-runtime";
import { Dropdown, useToast } from '@onefootprint/ui';
import { useStore } from '@/components/playbook-builder';
import useEdit from '@/components/playbook-builder/hooks/use-edit';
import { withSubject } from '@/components/playbook-builder/utils/get-subject';
import { useClipboardNodes } from '../add-node-dialog/components/paste-node-button';
const EmployeeGraphActions = () => {
  const $ = _c(16);
  const {
    toast
  } = useToast();
  const {
    data: t0
  } = useStore();
  const {
    canEdit: editMode,
    graph
  } = t0;
  const editMutation = useEdit();
  const {
    getNodesToPaste,
    displayPasteButton
  } = useClipboardNodes();
  let t1;
  if ($[0] !== editMutation || $[1] !== getNodesToPaste || $[2] !== toast) {
    t1 = async () => {
      const nodesToPaste = await getNodesToPaste();
      if (!nodesToPaste?.length) {
        toast({
          title: "Nothing to paste",
          description: "There is nothing to paste from your clipboard.",
          variant: "error"
        });
        return;
      }
      await editMutation.mutateAsync({
        kind: "replace_graph",
        data: nodesToPaste
      });
      toast({
        title: "Success!",
        description: "The graph has been replaced with the nodes from your clipboard.",
        variant: "success"
      });
    };
    $[0] = editMutation;
    $[1] = getNodesToPaste;
    $[2] = toast;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleReplaceGraph = t1;
  let t2;
  if ($[4] !== graph || $[5] !== toast) {
    t2 = () => {
      const nodesToCopy = graph.nodes.map(withSubject(graph));
      navigator.clipboard.writeText(JSON.stringify(nodesToCopy, null, 2));
      toast({
        title: "Copied!",
        description: "The graph's nodes have been copied to your clipboard."
      });
    };
    $[4] = graph;
    $[5] = toast;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleCopyNodes = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Dropdown.GroupTitle>Employee-only actions</Dropdown.GroupTitle>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = !editMode || !displayPasteButton || editMutation.isPending;
  let t5;
  if ($[8] !== handleReplaceGraph || $[9] !== t4) {
    t5 = <Dropdown.Item disabled={t4} onSelect={handleReplaceGraph}>Replace graph (from clipboard)</Dropdown.Item>;
    $[8] = handleReplaceGraph;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== handleCopyNodes) {
    t6 = <Dropdown.Item onSelect={handleCopyNodes}>Copy nodes</Dropdown.Item>;
    $[11] = handleCopyNodes;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <Dropdown.Group>{t3}{t5}{t6}</Dropdown.Group>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default EmployeeGraphActions;